module.exports = __webpack_public_path__ + "static/media/pound-sign.e7706144.svg";